import { useEffect } from 'react'
import { ICustomGeolocation } from '../../interfaces/IFilters'
import {
  getGeolocationCurrentPosition,
  setGeolocationToLocalStorage,
} from '../../utils/filters'

/**
 * Hook used to get geolocation and to set button disable status.
 */
export const useGeolocation = ({
  isFocused,
  setIsDisabled,
}: ICustomGeolocation) => {
  useEffect(() => {
    if (!isFocused) {
      return
    }

    const updateCoordinates = (data: GeolocationPosition) => {
      setGeolocationToLocalStorage(data)

      if (data.coords.latitude && data.coords.longitude) {
        setIsDisabled(false)
      }
    }

    const errorCallback = () => {
      setIsDisabled(true)
    }

    getGeolocationCurrentPosition(updateCoordinates, errorCallback)
  }, [isFocused, setIsDisabled])
}
